"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ThumbDown20Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_14195_25781)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.29606 12.25C4.82831 12.25 3.75353 10.8674 4.11559 9.44497L4.92632 6.25996C5.26472 4.93053 6.46179 4 7.83362 4L16.0016 4L16.0016 11.5H13.0016L11.758 15.2308C11.6049 15.6901 11.175 16 10.6907 16H10.6522C9.29128 16 8.19109 14.9703 8.04371 13.6757C8.02291 13.493 8.02109 13.305 8.04021 13.1138L8.11834 12.3325C8.12276 12.2883 8.08808 12.25 8.04371 12.25H6.29606ZM11.5016 11.2566L11.5016 5.5L7.83362 5.5C7.1477 5.5 6.54917 5.96527 6.37997 6.62998L5.56924 9.81499C5.44855 10.2891 5.80681 10.75 6.29606 10.75H8.04371C8.97552 10.75 9.70361 11.5545 9.6109 12.4817L9.53276 13.2631C9.47419 13.8488 9.8742 14.366 10.4279 14.4777L11.5016 11.2566ZM13.0016 10H14.5016L14.5016 5.5H13.0016L13.0016 10Z", fill: "#868A98" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_14195_25781" },
                react_1.default.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(4 4)" }))));
}
function ThumbDown20(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ThumbDown20Svg, Object.assign({}, svgProps)));
}
exports.default = ThumbDown20;
//# sourceMappingURL=ThumbDown20.js.map